export const nl = {
  daterange: {
    on: 'Op {1}',
    to: '{1} tot {2}',
    after: 'Na {1}',
    before: 'Voor {1}',
    today: 'Vandaag',
    yesterday: 'Gisteren',
    tomorrow: 'Morgen',
    last: 'Laatst {1}',
    next: 'Volgende {1}',
  },
  pikaday: {
    today: 'Vandaag',
    previousMonth: 'Vorige maand',
    nextMonth: 'Volgende maand',
    months: [
      'Januari',
      'Februari',
      'Maart',
      'April',
      'Mei',
      'Juni',
      'Juli',
      'Augustus',
      'September',
      'Oktober',
      'November',
      'December',
    ],
    weekdays: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
    weekdaysShort: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
  },
};
